(function () {
  'use strict';
  if (window.kpPreorderLoaded) return;
  window.kpPreorderLoaded = true;

  var data = document.getElementById('kp-preorder-data');
  if (!data) return;
  var variants;
  try { variants = JSON.parse(data.textContent).variants; } catch (error) { return; }
  if (!variants || !Object.keys(variants).length) return;

  var confirmed = Object.create(null);
  var queue = [];
  var active = null;
  var dialog, body, confirmButton, cancelButton;
  var pendingForms = typeof WeakSet === 'function' ? new WeakSet() : null;

  function isConfirmed(product) {
    var key = 'kp-preorder-ok:' + product.product_id;
    if (confirmed[key]) return true;
    try { return window.sessionStorage.getItem(key) === '1'; } catch (error) { return false; }
  }

  function markConfirmed(product) {
    var key = 'kp-preorder-ok:' + product.product_id;
    confirmed[key] = true;
    try { window.sessionStorage.setItem(key, '1'); } catch (error) { /* Memory covers blocked storage. */ }
  }

  function isAdd(url) {
    try { return /\/cart\/add(?:\.js)?$/.test(new URL(url, document.baseURI).pathname); }
    catch (error) { return false; }
  }

  function productsIn(payload) {
    var ids = [];
    if (payload instanceof FormData || payload instanceof URLSearchParams) {
      payload.forEach(function (value, key) {
        if (key === 'id' || /^items\[[^\]]*\]\[id\]$/.test(key)) ids.push(value);
      });
    } else if (typeof payload === 'string') {
      try { return productsIn(JSON.parse(payload)); }
      catch (error) { return productsIn(new URLSearchParams(payload)); }
    } else if (payload && typeof payload === 'object') {
      if (payload.id != null) ids.push(payload.id);
      if (Array.isArray(payload.items)) payload.items.forEach(function (item) {
        if (item) ids.push(item.id);
      });
    }
    var seen = Object.create(null);
    return ids.reduce(function (products, id) {
      var product = Object.prototype.hasOwnProperty.call(variants, String(id)) && variants[String(id)];
      if (product && !seen[product.product_id] && !isConfirmed(product)) {
        seen[product.product_id] = true;
        products.push(product);
      }
      return products;
    }, []);
  }

  function focus(element) {
    if (element && element.isConnected && typeof element.focus === 'function') element.focus({ preventScroll: true });
  }

  function buildDialog() {
    if (dialog) return;
    dialog = document.createElement('div');
    dialog.className = 'kp-po-dialog';
    dialog.hidden = true;
    dialog.setAttribute('data-kp-po-dialog', '');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'kp-po-title');
    dialog.innerHTML = '<div class="kp-po-backdrop" data-kp-po-backdrop></div>' +
      '<div class="kp-po-card"><h2 class="kp-po-title" id="kp-po-title" data-kp-po-title>Heads up: this is a pre-order</h2>' +
      '<p class="kp-po-body" data-kp-po-body></p>' +
      '<button type="button" class="kp-po-confirm" data-kp-po-confirm>Add pre-order</button>' +
      '<button type="button" class="kp-po-cancel" data-kp-po-cancel>Cancel</button></div>';
    document.body.appendChild(dialog);
    body = dialog.querySelector('[data-kp-po-body]');
    confirmButton = dialog.querySelector('[data-kp-po-confirm]');
    cancelButton = dialog.querySelector('[data-kp-po-cancel]');
    confirmButton.addEventListener('click', function () { close(true); });
    cancelButton.addEventListener('click', function () { close(false); });
    dialog.querySelector('[data-kp-po-backdrop]').addEventListener('click', function () { close(false); });
    window.addEventListener('keydown', function (event) {
      if (!active) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        close(false);
      } else if (event.key === 'Tab') {
        event.preventDefault();
        event.stopImmediatePropagation();
        var buttons = [confirmButton, cancelButton];
        var index = buttons.indexOf(document.activeElement);
        focus(buttons[index < 0 ? (event.shiftKey ? 1 : 0) : (index + 1) % 2]);
      }
    }, true);
  }

  function advance() {
    if (active || !queue.length) return;
    var next = queue.shift();
    next.products = next.products.filter(function (product) { return !isConfirmed(product); });
    if (!next.products.length) {
      finishAll(next, true);
      advance();
      return;
    }
    buildDialog();
    active = next;
    body.textContent = next.products.map(function (product) {
      var ships = String(product.ships || 'later');
      if (/^week/i.test(ships)) ships = 'the ' + ships.charAt(0).toLowerCase() + ships.slice(1);
      return product.name + ' ships ' + ships + '.';
    }).join(' ') + ' Everything else in your order ships now.';
    dialog.hidden = false;
    focus(confirmButton);
  }

  function close(accepted) {
    if (!active) return;
    var previous = active;
    if (accepted) previous.products.forEach(markConfirmed);
    active = null;
    dialog.hidden = true;
    focus(previous.trigger);
    try { finishAll(previous, accepted); } finally { advance(); }
  }

  function finishAll(entry, accepted) {
    entry.finishes.forEach(function (finish) {
      try { finish(accepted); } catch (error) { setTimeout(function () { throw error; }); }
    });
  }

  function sameProducts(a, b) {
    return a.length === b.length && a.every(function (product) {
      return b.some(function (other) { return other.product_id === product.product_id; });
    });
  }

  // A second request for the same products while one is waiting shares that answer (one prompt, not two).
  function enqueue(products, trigger, finish) {
    var pending = active && sameProducts(active.products, products) ? active : null;
    for (var i = 0; !pending && i < queue.length; i++) if (sameProducts(queue[i].products, products)) pending = queue[i];
    if (pending) { pending.finishes.push(finish); return; }
    queue.push({ products: products, trigger: trigger, finishes: [finish] });
    advance();
  }

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !isAdd(form.action)) return;
    var products = productsIn(new FormData(form));
    if (!products.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    // Some grids fire two submits for one tap: hold the form once, re-submit it once.
    if (pendingForms && pendingForms.has(form)) return;
    if (pendingForms) pendingForms.add(form);
    var submitter = event.submitter;
    enqueue(products, submitter || document.activeElement, function (accepted) {
      if (pendingForms) pendingForms.delete(form);
      if (accepted) {
        if (submitter) form.requestSubmit(submitter);
        else form.requestSubmit();
      }
    });
  }, true);

  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;
  window.fetch = function (input, init) {
    var args = arguments;
    var receiver = this;
    var request = typeof Request !== 'undefined' && input instanceof Request;
    var method = (init && init.method) || (request && input.method) || 'GET';
    function send() { return originalFetch.apply(receiver, args); }
    if (String(method).toUpperCase() !== 'POST' || !isAdd(request ? input.url : input)) return send();
    var trigger = active && dialog.contains(document.activeElement) ? active.trigger : document.activeElement;
    function inspect(payload) {
      var products = productsIn(payload);
      if (!products.length) return send();
      return new Promise(function (resolve, reject) {
        enqueue(products, trigger, function (accepted) {
          if (accepted) {
            try { resolve(send()); } catch (error) { reject(error); }
          } else {
            resolve(new Response(JSON.stringify({ status: 422, message: 'Not added', description: 'Pre-order not added.' }), {
              status: 422, headers: { 'Content-Type': 'application/json' }
            }));
          }
        });
      });
    }
    if (init && init.body != null) return inspect(init.body);
    if (request) {
      var copy;
      try { copy = input.clone(); } catch (error) { return send(); }
      var type = copy.headers.get('Content-Type') || '';
      var read = /multipart\/form-data/i.test(type) ? copy.formData() : copy.text();
      return read.then(inspect, send);
    }
    return send();
  };
}());
